import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import BaseListing from './BaseListing'

import '@loyal_template/benefits.css'

import { Filter } from '../Filter'
import { Button } from 'loyal-react'
import InfiniteScroll from 'react-infinite-scroller'

// #region IMPORT IMG
import Ubook from '@loyal_images/brand/cards-benefits/img_ubook.png'
import DrogariaSP from '@loyal_images/brand/cards-benefits/img_drogaria_sp.png'
import DrogariaPacheco from '@loyal_images/brand/cards-benefits/img_drogaria_pacheco.png'
import Dasa from '@loyal_images/brand/cards-benefits/cards-new/dasa_new.png'
import Farmadelivery from '@loyal_images/brand/cards-benefits/img_farma_delivery.png'
import Mistral from '@loyal_images/brand/cards-benefits/img_mistral.png'
import PicMe from '@loyal_images/brand/cards-benefits/img_picme.png'
import Evino from '@loyal_images/brand/cards-benefits/img_evino.png'
import Centauro from '@loyal_images/brand/cards-benefits/img_centauro.png'
import Netshoes from '@loyal_images/brand/cards-benefits/img_netshoes.png'
import Marisa from '@loyal_images/brand/cards-benefits/img_marisa.png'
import Renner from '@loyal_images/brand/cards-benefits/img_renner.png'
import Shoestock from '@loyal_images/brand/cards-benefits/img_shoestock.png'
import StudioGeek from '@loyal_images/brand/cards-benefits/img_studio_geek.png'
import Zattini from '@loyal_images/brand/cards-benefits/img_zattini.png'
import Petz from '@loyal_images/brand/cards-benefits/img_pets.png'
import GiulianaFlores from '@loyal_images/brand/cards-benefits/img_giuliana_flores.png'
import CestasMichelli from '@loyal_images/brand/cards-benefits/img_cestas_michelli.png'
import Sony from '@loyal_images/brand/cards-benefits/img_sony.png'
import Nespresso from '@loyal_images/brand/cards-benefits/img_nespresso.png'
import Conectcar from '@loyal_images/brand/cards-benefits/img_conectcar.png'
import HoteisCom from '@loyal_images/brand/cards-benefits/img_hoteis.png'
import Movida from '@loyal_images/brand/cards-benefits/img_movida.png'
import Natura from '@loyal_images/brand/cards-benefits/img_natura.png'
import Unidas from '@loyal_images/brand/cards-benefits/img_unidas.png'
import Hertz from '@loyal_images/brand/cards-benefits/img_hertz.png'
import MenuPersonnalite from '@loyal_images/brand/cards-benefits/img_menu_personnalite.png'
import SociedadeMesa from '@loyal_images/brand/cards-benefits/img_sociedade_mesa.png'
import Orfeu from '@loyal_images/brand/cards-benefits/img_cafeorfeu.png'
import Wine from '@loyal_images/brand/cards-benefits/img_wine.png'
import AMARO from '@loyal_images/brand/cards-benefits/img_amaro.png'
import LoungePersonnalite from '@loyal_images/brand/cards-benefits/img_lounge_personnalite.png'
import LivUp from '@loyal_images/brand/cards-benefits/img_livup.png'
import EmporioNestle from '@loyal_images/brand/cards-benefits/img_emporio_nestle.png'
import Aramis from '@loyal_images/brand/cards-benefits/img_aramis.png'
import ShopClub from '@loyal_images/brand/cards-benefits/img_shopclub.png'
import Loccitane from '@loyal_images/brand/cards-benefits/img_loccitane.png'
import Reserva from '@loyal_images/brand/cards-benefits/img_reserva.png'
import Cobasi from '@loyal_images/brand/cards-benefits/cards-new/cobasi.jpg'
import Asesc from '@loyal_images/brand/cards-benefits/cards-new/5asesc.png'
import Lepostiche from '@loyal_images/brand/cards-benefits/cards-new/lepostiche.png'
import OriginalExperience from '@loyal_images/brand/cards-benefits/cards-new/logo-original-experience.png'
import Looccitane from '@loyal_images/brand/cards-benefits/cards-new/looccitane.png'
import Oldflix from '@loyal_images/brand/cards-benefits/cards-new/oldflix.png'
import Sephora from '@loyal_images/brand/cards-benefits/cards-new/sephora.png'
import Tokbeauty from '@loyal_images/brand/cards-benefits/cards-new/tokbeauty.png'
import Funstock from '@loyal_images/brand/cards-benefits/cards-new/funstock.jpg'
import Comschool from '@loyal_images/brand/cards-benefits/cards-new/comschool.png'
import Camicado from '@loyal_images/brand/cards-benefits/cards-new/camicado.png'
import Vinu from '@loyal_images/brand/cards-benefits/cards-new/vinu.png'
import Berenice from '@loyal_images/brand/cards-benefits/cards-new/berenice.png'
import EspacoLaser from '@loyal_images/brand/cards-benefits/cards-new/espaco-laser.png'
import Eudora from '@loyal_images/brand/cards-benefits/cards-new/eudora.png'
import HertzInternacional from '@loyal_images/brand/cards-benefits/cards-new/hertz-internacional.png'
import Invisalign from '@loyal_images/brand/cards-benefits/cards-new/invisalign.png'
import Azaleia from '@loyal_images/brand/cards-benefits/cards-new/azaleia.png'
import Mobly from '@loyal_images/brand/cards-benefits/cards-new/mobly.jpg'
import Prontolight from '@loyal_images/brand/cards-benefits/cards-new/prontolight.png'
import ProtecBag from '@loyal_images/brand/cards-benefits/cards-new/protec-bag.png'
import Turbi from '@loyal_images/brand/cards-benefits/cards-new/turbi.png'
import Adcos from '@loyal_images/brand/cards-benefits/cards-new/adcos.png'
import DigitalHouse from '@loyal_images/brand/cards-benefits/cards-new/digital-house.png'
import visa from '@loyal_images/brand/cards-benefits/cards-new/visa.png'
import MasterCard from '@loyal_images/brand/cards-benefits/cards-new/master-card.png'
import Zenklub from '@loyal_images/brand/cards-benefits/cards-new/zenklub.png'
import StudioZ from '@loyal_images/brand/cards-benefits/cards-new/studio.png'
import Microsoft from '@loyal_images/brand/cards-benefits/cards-new/microsoft.png'
import Carnegie from '@loyal_images/brand/cards-benefits/cards-new/carnegie.png'
import VivoAssicom from '@loyal_images/brand/cards-benefits/cards-new/vivo.png'
import Avec from '@loyal_images/brand/cards-benefits/cards-new/avec.png'
import Bookplay from '@loyal_images/brand/cards-benefits/cards-new/bookplay.png'
import Taba from '@loyal_images/brand/cards-benefits/cards-new/taba.png'
import Beetools from '@loyal_images/brand/cards-benefits/cards-new/beetools.png'
import Cna from '@loyal_images/brand/cards-benefits/cards-new/cna.jpg'
import Watts from '@loyal_images/brand/cards-benefits/cards-new/watts.png'
import CulturaInglesa from '@loyal_images/brand/cards-benefits/cards-new/cultura_inglesa.png'
import EssentialIndiomas from '@loyal_images/brand/cards-benefits/cards-new/essential_indiomas.png'
import Dermarge from '@loyal_images/brand/cards-benefits/cards-new/dermarge.png'
import RendsCards from '@loyal_images/brand/cards-benefits/cards-new/rends_cards.png'
import Mahogany from '@loyal_images/brand/cards-benefits/cards-new/mahogany.png'
import Icarros from '@loyal_images/brand/cards-benefits/cards-new/icarros.png'
import LocalizaNew from '@loyal_images/brand/cards-benefits/cards-new/localiza.png'
import Marelli from '@loyal_images/brand/cards-benefits/cards-new/marelli.png'
import ZenApp from '@loyal_images/brand/cards-benefits/cards-new/zen-app.png'
import LogoFia from '@loyal_images/brand/cards-benefits/cards-new/logo-fia.png'
import Hering from '@loyal_images/brand/cards-benefits/cards-new/hering.png'
import Yuca from '@loyal_images/brand/cards-benefits/cards-new/yuca.png'

// #endregion

class ItauCardListing extends BaseListing {
  componentDidMount () {
    this.benefits = [
      // #region ITAUCARD
      {
        link:
         'https://www.giulianaflores.com.br/?partner=top_itaucard15perene&utm_source=itau&utm_medium=parcerias&utm_campaign=perene',
        name: 'Giuliana Flores',
        discount: 15,
        image: GiulianaFlores,
        descriptionHtml: <span>15% off</span>,
        profile: 'quem tem Itaucard',
        category: 'Para você',
        partner: 'Giuliana Flores',
        alt: 'Logo Giuliana Flores'
      },
      {
        link: 'http://try.ubook.com/itaucard',
        name: 'Ubook',
        discount: 0,
        image: Ubook,
        descriptionHtml: <span>3 meses por R$14,90</span>,
        profile: 'quem tem Itaucard',
        category: 'Entretenimento',
        partner: 'Ubook',
        alt: 'Logo Ubook'
      },
      {
        link: 'https://www.itau.com.br/content/dam/itau/cartoes/beneficios/PDF_Beneficio_Farmacia.pdf',
        name: 'Drogaria São Paulo',
        discount: 35,
        image: DrogariaSP,
        descriptionHtml: <span>Até 35% off</span>,
        profile: 'quem tem Itaucard',
        category: 'Bem estar e saúde',
        partner: 'Drogaria São Paulo',
        alt: 'Logo Drogaria São Paulo'
      },
      {
        link: 'https://www.itau.com.br/content/dam/itau/cartoes/beneficios/PDF_Beneficio_Farmacia.pdf',
        name: 'Drogaria Pacheco',
        discount: 35,
        image: DrogariaPacheco,
        descriptionHtml: <span>Até 35% off</span>,
        profile: 'quem tem Itaucard',
        category: 'Bem estar e saúde',
        partner: 'Drogaria Pacheco',
        title: 'Vai para Drogaria Pacheco',
        alt: 'Logo Drogaria Pacheco'
      },
      {
        link: 'https://dasa.com.br/parcerias/itau',
        name: 'Dasa',
        discount: 25,
        image: Dasa,
        descriptionHtml: <span>Até 25% de descontos em exames</span>,
        profile: 'quem tem Itaucard',
        category: 'Bem estar e saúde',
        partner: 'Dasa',
        alt: 'Logo Dasa'
      },
      {
        link: 'https://itaucard.farmadelivery.com.br',
        name: 'Farmadelivery',
        discount: 12,
        image: Farmadelivery,
        descriptionHtml: <span>Até 12% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Bem estar e saúde',
        partner: 'Farmadelivery',
        alt: 'Logo Farmadelivery'
      },
      {
        link: 'https://www.clubepicme.com.br/itaucard',
        name: 'Pic-Me',
        discount: 20,
        image: PicMe,
        descriptionHtml: <span>20% de desconto nas assinaturas</span>,
        profile: 'quem tem Itaucard',
        category: 'Alimentos',
        partner: 'Pic-Me',
        title: 'Vai para Pic-Me',
        alt: 'Logo Pic-Me'
      },
      {
        link: 'http://www.mistral.com.br/itaucard',
        name: 'Mistral',
        discount: 20,
        image: Mistral,
        descriptionHtml: <span>Até 20% de desconto em até 7x sem juros</span>,
        profile: 'quem tem Itaucard',
        category: 'Bebidas',
        partner: 'Mistral',
        alt: 'Logo Mistral'
      },
      {
        link: 'https://www.nespressobenefits.com.br/',
        name: 'Nespresso',
        discount: 20,
        image: Nespresso,
        descriptionHtml: <span>20% off com o cupom it0615</span>,
        profile: 'quem tem Itaucard',
        category: 'Bebidas',
        partner: 'Nespresso',
        alt: 'Logo Nespresso'
      },
      {
        link: 'https://www.marisa.com.br/parcerias/c/itaucard',
        name: 'Marisa',
        discount: 15,
        image: Marisa,
        descriptionHtml: <span>20% off com o cupom ITAUMARISA20</span>,
        profile: 'quem tem Itaucard',
        category: 'Moda',
        partner: 'Marisa',
        alt: 'Logo Marisa'
      },
      {
        link: 'https://www.lojasrenner.com.br/b2b/itaucard',
        name: 'Renner',
        discount: 15,
        image: Renner,
        descriptionHtml: <span>até 15% em produtos</span>,
        profile: 'quem tem Itaucard',
        category: 'Moda',
        partner: 'Renner',
        alt: 'Logo Renner'
      },
      {
        link:
          'https://www.shoestock.com.br/especial/itaucard?campaign=netpro_itaucard&utm_source=b2b_itaucard&utm_medium=redirect-itaucard&utm_campaign=b2b_itaucard',
        name: 'Shoestock',
        discount: 15,
        image: Shoestock,
        descriptionHtml: <span>15% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Moda',
        partner: 'Shoestock',
        alt: 'Logo Shoestock'
      },
      {
        link: 'https://www.studiogeek.com.br/',
        name: 'Studio Geek',
        discount: 25,
        image: StudioGeek,
        descriptionHtml: <span>25% off com cupom ITAUGEEK </span>,
        profile: 'quem tem Itaucard',
        category: 'Moda',
        partner: 'Studio Geek',
        alt: 'Logo Studio Geek'
      },
      {
        link: 'https://oldflix.parceriasonline.com.br/itaucard',
        name: 'Oldflix',
        discount: 15,
        image: Oldflix,
        descriptionHtml: <span>15% de desconto na assinatura</span>,
        profile: 'quem tem Itaucard',
        category: 'Entretenimento',
        partner: 'Oldflix',
        alt: 'Logo Oldflix'
      },
      {
        link: 'https://sephora.parceriasonline.com.br/itaucard',
        name: 'Sephora',
        discount: 5,
        image: Sephora,
        descriptionHtml: <span>5% off em compras acima de R$ 299</span>,
        profile: 'quem tem Itaucard',
        category: 'Perfumaria',
        partner: 'Sephora',
        alt: 'Logo Sephora'
      },
      {
        link: 'http://onelink.to/tokbeauty',
        name: 'TokBeauty',
        discount: 40,
        image: Tokbeauty,
        descriptionHtml: <span>40% off na 1ª compra com o cupom ITAUCARD40</span>,
        profile: 'quem tem Itaucard',
        category: 'Perfumaria',
        partner: 'TokBeauty',
        alt: 'Logo TokBeauty'
      },
      {
        link: 'https://loja.5asec.com.br/home',
        name: '5àSec Lavanderia',
        discount: 10,
        image: Asesc,
        descriptionHtml: <span>10% de desconto com o cupom ITAUCARD10 </span>,
        profile: 'quem tem Itaucard',
        category: 'Para você',
        partner: '5àSec Lavanderia',
        alt: 'Logo 5àSec Lavanderia'
      },
      {
        link: 'https://www.lepostiche.com.br/?utm_source=itaucard&utm_medium=parceria&utm_campaign=lepostiche&utm_content=cupom',
        name: 'Le Postiche',
        discount: 10,
        image: Lepostiche,
        descriptionHtml: <span>Até 10% de desconto com o cupom ITAUCARD10 </span>,
        profile: 'quem tem Itaucard',
        category: 'Moda',
        partner: 'Le Postiche',
        alt: 'Logo Le Postiche'
      },
      {
        link: 'https://loccitaneenprovence.parceriasonline.com.br/itaucard',
        name: `L'Occitane en Provence`,
        discount: 10,
        image: Looccitane,
        descriptionHtml: <span>10% off com o cupom ITAUCARD</span>,
        profile: 'quem tem Itaucard',
        category: 'Perfumaria',
        partner: `L'Occitane en Provence`,
        alt: `Logo L'Occitane en Provence`
      },
      {
        link: 'https://vinu.club/',
        name: 'VINU',
        discount: 20,
        image: Vinu,
        descriptionHtml: <span>20% de desconto com o cupom VINUITAU </span>,
        profile: 'quem tem Itaucard',
        category: 'Bebidas',
        partner: 'VINU',
        alt: 'Logo VINU'
      },
      {
        link: 'https://clube.camicado.com.br/b2b/itaucard',
        name: 'Camicado',
        discount: 11,
        image: Camicado,
        descriptionHtml: <span>11% de desconto + frete grátis </span>,
        profile: 'quem tem Itaucard',
        category: 'Casa e Decoração',
        partner: 'Camicado',
        alt: 'Logo Camicado'
      },
      {
        link: 'https://comschool.co/itaucard',
        name: 'ComSchool',
        discount: 30,
        image: Comschool,
        descriptionHtml: <span>30% off com o cupom ITAUCARD-30</span>,
        profile: 'quem tem Itaucard',
        category: 'Educação',
        partner: 'ComSchool',
        alt: 'Logo ComSchool'
      },
      {
        link: 'https://blog.funstock.com.br/itaucard-e-funstock/',
        name: 'Funstock',
        discount: 15,
        image: Funstock,
        descriptionHtml: <span>15% off </span>,
        profile: 'quem tem Itaucard',
        category: 'Para você',
        partner: 'Funstock',
        alt: 'Logo Funstock'
      },
      {
        link: 'https://www.originalexperience.com.br/',
        name: 'Original Experience',
        discount: 10,
        image: OriginalExperience,
        descriptionHtml: <span>10% de desconto com o cupom Itaucard10  </span>,
        profile: 'quem tem Itaucard',
        category: 'Entretenimento',
        partner: 'Original Experience',
        alt: 'Logo Original Experience'
      },
      {
        link: 'https://corporativostore.sony.com.br/itau',
        name: 'Sony',
        discount: 15,
        image: Sony,
        descriptionHtml: <span>Até 15% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Eletroeletrônicos',
        partner: 'Sony',
        alt: 'Logo Sony'
      },
      {
        link: 'https://parceiros.conectcar.com/ofertas-itaucard/',
        name: 'Conectcar',
        image: Conectcar,
        descriptionHtml: <span>12 meses grátis no Plano Completo</span>,
        profile: 'quem tem Itaucard',
        category: 'Hotelaria',
        partner: 'Conectcar',
        alt: 'Logo Conectcar'
      },
      {
        link:
          'https://www.hoteis.com/ofertas-de-hoteis/descontos-itaucard?locale=pt_BR&pos=HCOM_BR&rffrid=mdp.hcom.br.404.000.00.00',
        name: 'Hoteis.com',
        discount: 10,
        image: HoteisCom,
        descriptionHtml: <span>10% de desconto.</span>,
        profile: 'quem tem Itaucard',
        category: 'Hotelaria',
        partner: 'Hoteis.com',
        alt: 'Logo Hoteis.com'
      },
      {
        link: 'https://www.localizahertz.com/brasil/pt-br/ofertas/itaucard',
        name: 'Localiza',
        discount: 10,
        image: LocalizaNew,
        descriptionHtml: <span>10% off nas reservas</span>,
        profile: 'quem tem Itaucard',
        category: 'Transporte',
        partner: 'Localiza',
        alt: 'Logo Localiza'
      },
      {
        link: 'https://parcerias.movida.com.br/itaucard',
        name: 'Movida',
        discount: 10,
        image: Movida,
        descriptionHtml: <span>10% off</span>,
        profile: 'quem tem Itaucard',
        category: 'Transporte',
        partner: 'Movida',
        alt: 'Logo Movida'
      },
      {
        link: 'https://www.natura.com.br/parceiros/itaucard',
        name: 'Natura',
        discount: 10,
        image: Natura,
        descriptionHtml: <span>10% off em produtos selecionados </span>,
        profile: 'quem tem Itaucard',
        category: 'Perfumaria',
        partner: 'Natura',
        alt: 'Logo Natura'
      },
      // #endregion

      // #region PERSONNALITE
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/viagem/movida/',
        name: 'Movida',
        discount: 15,
        image: Movida,
        descriptionHtml: <span>Até 15% off sobre a diária dos carros</span>,
        profile: 'pra quem é Personnalité',
        category: 'Viagem',
        partner: 'Movida',
        alt: 'Logo Movida'
      },
      {
        link:
          'https://www.itau.com.br/personnalite/experiencia/viagem/unidas/',
        name: 'Unidas',
        discount: 25,
        image: Unidas,
        descriptionHtml: <span>Descontos de Até 25%</span>,
        profile: 'pra quem é Personnalité',
        category: 'Viagem',
        partner: 'Unidas',
        alt: 'Logo Unidas'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/viagem/hertz/',
        name: 'Hertz',
        discount: 20,
        image: Hertz,
        descriptionHtml: <span>20% de desconto na locação de veículos</span>,
        profile: 'pra quem é Personnalité',
        category: 'Viagem',
        partner: 'Hertz',
        alt: 'Logo Hertz'
      },
      {
        link:
          'https://www.itau.com.br/personnalite/experiencia/viagem/localiza/',
        name: 'Localiza',
        discount: 15,
        image: LocalizaNew,
        descriptionHtml: <span>Até 15% off  nas reservas </span>,
        profile: 'pra quem é Personnalité',
        category: 'Viagem',
        partner: 'Localiza',
        alt: 'Logo Localiza'
      },
      {
        link: 'https://www.ibeneficios.com.br/menupersonnalite',
        name: 'Menu Personnalité',
        discount: 0,
        image: MenuPersonnalite,
        descriptionHtml: <span>Um menu desgustação exclusivo</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Menu Personnalité',
        alt: 'Logo Menu Personnalité'
      },
      {
        link:
          'https://www.itau.com.br/personnalite/experiencia/gastronomia/sociedade-da-mesa/',
        name: 'Sociedade da mesa',
        discount: 0,
        image: SociedadeMesa,
        descriptionHtml: <span>Faça parte do Clube de vinhos</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Sociedade da mesa',
        alt: 'Logo Sociedade da mesa'
      },
      {
        link:
          'https://www.itau.com.br/personnalite/experiencia/gastronomia/nespresso',
        name: 'Nespresso',
        discount: 25,
        image: Nespresso,
        descriptionHtml: <span>Até 25% off em máquinas selecionadas</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Nespresso',
        alt: 'Logo Nespresso'
      },
      {
        link: 'https://www.mistral.com.br/parceria/personnalite',
        name: 'Mistral',
        discount: 25,
        image: Mistral,
        descriptionHtml: <span>Até 25% de desconto em até 7x sem juros </span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Mistral',
        alt: 'Logo Mistral'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/gastronomia/cafe-orfeu/',
        name: 'Orfeu',
        discount: 20,
        image: Orfeu,
        descriptionHtml: <span>20% de desconto em todos os cafés do site</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Orfeu',
        alt: 'Logo Orfeu'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/gastronomia/wine/',
        name: 'Wine',
        discount: 15,
        image: Wine,
        descriptionHtml: <span>15% de desconto em todas as mensalidades</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Wine',
        alt: 'Logo Wine'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/amaro/',
        name: 'AMARO',
        discount: 15,
        image: AMARO,
        descriptionHtml: <span>15% + frete grátis compras maior de R$199,00</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida',
        partner: 'AMARO',
        alt: 'Logo AMARO'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/cultura/lounge',
        name: 'Lounge Personnalité',
        discount: 0,
        image: LoungePersonnalite,
        descriptionHtml: <span>Louge Personnalité: Programação Especial</span>,
        profile: 'pra quem é Personnalité',
        category: 'Cultura',
        partner: 'Lounge Personnalité',
        alt: 'Logo Lounge Personnalité'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/sephora/',
        name: 'Sephora',
        discount: 10,
        image: Sephora,
        descriptionHtml: <span>até 50% off em produtos selecionados</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida',
        partner: 'Sephora',
        alt: 'Logo Sephora'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/viagem/conectcar/',
        name: 'Conectcar',
        discount: 30,
        image: Conectcar,
        descriptionHtml: <span>Confira as condições exclusivas</span>,
        profile: 'pra quem é Personnalité',
        category: 'Viagem',
        partner: 'Conectcar',
        alt: 'Logo ConectCar'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/5-a-sec/',
        name: '5àSec Lavanderia',
        discount: 20,
        image: Asesc,
        descriptionHtml: <span>20% off com o cupom PERSONNALITE20</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida',
        partner: '5àSec Lavanderia',
        alt: 'Logo 5àSec Lavanderia'
      },
      // #endregion

      // #region IUPP
      {
        link: 'https://www.marisa.com.br',
        name: 'Marisa',
        image: Marisa,
        discount: 15,
        descriptionHtml: <span> 20% off nas compras online com cupom IUPP20 </span>,
        profile: 'pra todo mundo',
        category: 'Moda',
        partner: 'Marisa',
        alt: 'Marisa'
      },
      {
        link: 'https://azaleia.parceriasonline.com.br/iupp',
        name: 'Azaleia',
        discount: 10,
        image: Azaleia,
        descriptionHtml: <span>10% off com o cupom AZALEIA10</span>,
        profile: 'pra todo mundo',
        category: 'Moda',
        partner: 'Azaleia',
        alt: 'Logo Azaleia'
      },
      {
        link: 'https://itau.centauro.com.br/',
        name: 'Centauro',
        discount: 15,
        image: Centauro,
        descriptionHtml: <span>15% off com o cupom iupp15</span>,
        profile: 'pra todo mundo',
        category: 'Esporte',
        partner: 'Centauro',
        alt: 'Logo Centauro'
      },
      {
        link: 'https://petz.parceriasonline.com.br/iupp',
        name: 'Petz',
        discount: 10,
        image: Petz,
        descriptionHtml: <span>10% off acima R$120 com cupom PARCEIROS10PETZ</span>,
        profile: 'pra todo mundo',
        category: 'Pets',
        partner: 'Petz',
        alt: 'Logo Petz'
      },
      {
        link: 'https://clube.netshoes.com.br/iupp',
        name: 'Netshoes',
        discount: 15,
        image: Netshoes,
        descriptionHtml: <span>15% off pelo hotsite com o cupom iupp</span>,
        profile: 'pra todo mundo',
        category: 'Esporte',
        partner: 'Netshoes',
        alt: 'Logo Netshoes'
      },
      {
        link: 'https://www.evino.com.br/',
        name: 'Evino',
        discount: 10,
        image: Evino,
        descriptionHtml: <span>10% off nas demais com o cupom 10-IUPP</span>,
        profile: 'pra todo mundo',
        category: 'Bebidas',
        partner: 'Evino',
        alt: 'Logo Evino'
      },
      {
        link: 'https://www.zattini.com.br/iupp',
        name: 'Zattini',
        discount: 15,
        image: Zattini,
        descriptionHtml: <span>15% off pelo hotsite com o cupom iupp</span>,
        profile: 'pra todo mundo',
        category: 'Moda',
        partner: 'Zattini',
        alt: 'Logo Zattini'
      },
      {
        link: 'https://www.stz.com.br/iuppdesconto',
        name: 'StudioZ',
        image: StudioZ,
        discount: 10,
        descriptionHtml: <span>10% off com o cupom IUPPDESCONTO</span>,
        profile: 'pra todo mundo',
        category: 'Moda',
        partner: 'StudioZ',
        alt: 'Logo StudioZ'
      },
      {
        link: 'http://www.livup.com.br/',
        name: 'Liv up',
        discount: 10,
        image: LivUp,
        descriptionHtml: <span> IUPP10: 10% de desconto (sem limite por CPF)</span>,
        profile: 'pra todo mundo',
        category: 'Alimentos',
        partner: 'Liv up',
        alt: 'Logo Liv up'
      },
      {
        link: 'http://www.livup.com.br/',
        name: 'Liv up',
        discount: 15,
        image: LivUp,
        descriptionHtml: <span> IUPP15: 15% de desconto na primeira compra</span>,
        profile: 'pra todo mundo',
        category: 'Alimentos',
        partner: 'Liv up',
        alt: 'Logo Liv up'
      },
      {
        link: 'http://emporionestle.parceriasonline.com.br/iupp',
        name: 'Empório Nestlé',
        discount: 10,
        image: EmporioNestle,
        descriptionHtml: <span>10% em todos os produtos da loja</span>,
        profile: 'pra todo mundo',
        category: 'Alimentos',
        partner: 'Empório Nestlé',
        alt: 'Logo Empório Nestlé'
      },
      {
        link: 'https://www.aramis.com.br/',
        name: 'Aramis',
        discount: 15,
        image: Aramis,
        descriptionHtml: <span>15% off com o cupom iupp15</span>,
        profile: 'pra todo mundo',
        category: 'Moda',
        partner: 'Aramis',
        alt: 'Logo Aramis'
      },
      {
        link:
          'https://www.shopclub.com.br/iupp',
        name: 'ShopClub',
        discount: 45,
        image: ShopClub,
        descriptionHtml: <span>Até 40% off com o cupom iupp</span>,
        profile: 'pra todo mundo',
        category: 'Eletroeletrônicos',
        partner: 'ShopClub',
        alt: 'Logo ShopClub'
      },
      {
        link: 'https://loccitane.parceriasonline.com.br/iupp',
        name: `L'occitane`,
        discount: 15,
        image: Loccitane,
        descriptionHtml: <span>15% off com o cupom IUPP2020</span>,
        profile: 'pra todo mundo',
        category: 'Perfumaria',
        partner: `L'occitane`,
        alt: 'Logo loccitane'
      },
      {
        link: 'https://www.reserva.ink/iupp',
        name: 'Reserva',
        discount: 0,
        image: Reserva,
        descriptionHtml: <span>Camisetas personalizadas iupp por R$59,00</span>,
        profile: 'pra todo mundo',
        category: 'Moda',
        partner: 'Reserva',
        alt: 'Logo reserva'
      },
      {
        link: 'https://www.cestasmichelli.com.br/?partner=top_iupp25lancamento&utm_source=iupp&utm_medium=parcerias&utm_campaign=lancamento-iupp',
        name: 'Cestas Michelli',
        discount: 25,
        image: CestasMichelli,
        descriptionHtml: <span>15% off em todo o site</span>,
        profile: 'pra todo mundo',
        category: 'Para você',
        partner: 'Cestas Michelli',
        alt: 'Logo Cestas Michelli'
      },
      {
        link: 'https://www.cobasi.com.br',
        name: 'Cobasi',
        discount: 10,
        image: Cobasi,
        descriptionHtml: <span>10% de desconto com o cupom IUPP </span>,
        profile: 'pra todo mundo',
        category: 'Pets',
        partner: 'Cobasi',
        alt: 'Logo Cobasi'
      },
      {
        link: 'https://www.espacolaser.com.br/',
        name: 'EspaçoLaser',
        discount: 55,
        image: EspacoLaser,
        descriptionHtml: <span>55% off e veja o cupom no app Espaçolaser</span>,
        profile: 'Pra quem é funcionário',
        category: 'Bem estar e saúde',
        partner: 'Espaço Laser',
        alt: 'Logo Espaço Laser'
      },
      {
        link: 'https://parceria.sgrentals.com.br/itaucard',
        name: 'Hertz Internacional',
        discount: 15,
        image: HertzInternacional,
        descriptionHtml: <span>15% off sobre o valor da diária</span>,
        profile: 'quem tem Itaucard',
        category: 'Transporte',
        partner: 'Hertz Internacional',
        alt: 'Logo Hertz Internacional'
      },
      {
        link: 'https://iframe.sgrentals.com.br/iframe/home/?idUser=27248',
        name: 'Hertz Internacional',
        discount: 17,
        image: HertzInternacional,
        descriptionHtml: <span>Desconto de 17% em todo site</span>,
        profile: 'Pra quem é funcionário',
        category: 'Transporte',
        partner: 'Hertz Internacional',
        alt: 'Logo Hertz Internacional'
      },
      {
        link: 'https://www.eudora.com.br/',
        name: 'Eudora',
        discount: 20,
        image: Eudora,
        descriptionHtml: <span>10% off cupom o EUDORAITAUCARD10</span>,
        profile: 'quem tem Itaucard',
        category: 'Perfumaria',
        partner: 'Eudora',
        alt: 'Logo Eudora'
      },
      {
        link: 'https://www.invisalign.com.br/use-invisalign',
        name: 'Invisalign',
        image: Invisalign,
        descriptionHtml: <span>Transformar o seu sorriso ficou mais fácil</span>,
        profile: 'quem tem Itaucard',
        category: 'Bem estar e saúde',
        partner: 'Invisalign',
        alt: 'Logo Invisalign'
      },
      {
        name: 'Protec Bag',
        discount: 20,
        image: ProtecBag,
        descriptionHtml: <span>20% off com cupom ITAUCARD20 em lojas físicas</span>,
        profile: 'quem tem Itaucard',
        category: 'Hotelaria',
        partner: 'Protec Bag',
        alt: 'Logo Protec Bag'
      },
      {
        link: 'https://app.adjust.com/sm2tu1i?engagement_type=fallback_click&fallback=https%3A%2F%2Fturbi.com.br%2F',
        name: 'Turbi',
        image: Turbi,
        descriptionHtml: <span>R$60 OFF primeiro uso cupom: ItaucardTurbi60</span>,
        profile: 'quem tem Itaucard',
        category: 'Transporte',
        partner: 'Turbi',
        alt: 'Logo Turbi'
      },
      {
        link: 'https://www.quemdisseberenice.com.br/parceria-itaucard',
        name: 'Quem disse, Berenice?',
        discount: 10,
        image: Berenice,
        descriptionHtml: <span>10% off com o cupom ITAU10</span>,
        profile: 'quem tem Itaucard',
        category: 'Perfumaria',
        partner: 'Quem disse Berenice',
        alt: 'Logo Quem disse Berenice'
      },
      {
        link: 'https://www.invisalign.com.br/use-invisalign',
        name: 'Invisalign',
        image: Invisalign,
        descriptionHtml: <span>Transformar o seu sorriso ficou mais fácil</span>,
        profile: 'Pra quem é funcionário',
        category: 'Bem estar e saúde',
        partner: 'Invisalign',
        alt: 'Logo Invisalign'
      },
      {
        link: 'https://www.natura.com.br/parceiros/itau-colaboradores',
        name: 'Natura',
        discount: 12,
        image: Natura,
        descriptionHtml: <span>12% off em produtos selecionados </span>,
        profile: 'Pra quem é funcionário',
        category: 'Perfumaria',
        partner: 'Natura',
        alt: 'Logo Natura'
      },
      {
        link: 'https://lp.avec.app/iupp/',
        name: 'AVEC',
        image: Avec,
        discount: 20,
        descriptionHtml: <span>Até 40% off em beleza e bem-estar</span>,
        profile: 'Pra quem é funcionário',
        category: 'Bem estar e saúde',
        partner: 'AVEC',
        alt: 'AVEC'
      },
      {
        link: 'https://dev.bookplay.com.br/promo/itau/',
        name: 'Bookplay',
        image: Bookplay,
        descriptionHtml: <span>Plano anual por R$19,90 ao mês.</span>,
        profile: 'Pra quem é funcionário',
        category: 'Educação',
        partner: 'Bookplay',
        alt: 'Bookplay'
      },
      {
        link: 'https://dev.bookplay.com.br/promo/itau/gratis/',
        name: 'Bookplay',
        image: Bookplay,
        descriptionHtml: <span>Degustação gratis no 1º mês</span>,
        profile: 'Pra quem é funcionário',
        category: 'Educação',
        partner: 'Bookplay',
        alt: 'Bookplay'
      },
      {
        link: 'https://carnegiebrasil.com.br/store/',
        name: 'Carnegie',
        image: Carnegie,
        discount: 40,
        descriptionHtml: <span>40% de desconto</span>,
        profile: 'Pra quem é funcionário',
        category: 'Educação',
        partner: 'Carnegie',
        alt: 'Carnegie'
      },
      {
        link: 'https://banco341.assicom.org.br/password',
        name: 'Vivo',
        image: VivoAssicom,
        discount: 50,
        descriptionHtml: <span>Planos telefonia celular com até 50% de desconto</span>,
        profile: 'Pra quem é funcionário',
        category: 'Para você',
        partner: 'Vivo',
        alt: 'Vivo'
      },
      {
        link: 'https://bit.ly/2EUf6W0',
        name: 'Livup',
        image: LivUp,
        discount: 15,
        descriptionHtml: <span>15% de desconto com o cupom COLAB15</span>,
        profile: 'Pra quem é funcionário',
        category: 'Alimentos',
        partner: 'Livup',
        alt: 'Livup'
      },
      {
        link: 'https://lp.culturainglesa.com.br/parceriaitau',
        name: 'Cultura Inglesa',
        image: CulturaInglesa,
        discount: 15,
        descriptionHtml: <span>15% off para colaboradores do Itaú</span>,
        profile: 'Pra quem é funcionário',
        category: 'Educação',
        partner: 'Cultura Inglesa',
        alt: 'Cultura Inglesa'
      },
      {
        link: 'http://www.beetools.com.br/colaboradores-itau/',
        name: 'Beetools',
        image: Beetools,
        discount: 25,
        descriptionHtml: <span>Cursos de inglês com até 25% off </span>,
        profile: 'Pra quem é funcionário',
        category: 'Educação',
        partner: 'Beetools',
        alt: 'Beetools'
      },
      {
        link: 'https://cnago.parceriasonline.com.br/iuppcolaboradores',
        name: 'CNA GO',
        image: Cna,
        discount: 30,
        descriptionHtml: <span> 30% off com o cupom ITAUCOLAB30 </span>,
        profile: 'Pra quem é funcionário',
        category: 'Educação',
        partner: 'CNA GO',
        alt: 'CNA GO'
      },
      {
        link: 'https://www.wattsmobilidade.com/',
        name: 'WATTS MOBILIDADE ELÉTRICA',
        image: Watts,
        discount: 15,
        descriptionHtml: <span> 15% off + frete com cupom ITAUCOLABORADORES </span>,
        profile: 'Pra quem é funcionário',
        category: 'Transporte',
        partner: 'WATTS MOBILIDADE ELÉTRICA',
        alt: 'WATTS MOBILIDADE ELÉTRICA'
      },
      {
        link: 'https://materiais.ataba.com.br/iuppcolaboradores',
        name: 'A TABA',
        image: Taba,
        discount: 30,
        descriptionHtml: <span> 30% nos 3 primeiros meses em planos anuais </span>,
        profile: 'Pra quem é funcionário',
        category: 'Educação',
        partner: 'A TABA',
        alt: 'A TABA'
      },
      {
        link: 'https://www.originalexperience.com.br/',
        name: 'Original Experience',
        image: OriginalExperience,
        discount: 12,
        descriptionHtml: <span> 12% off com cupom IUPPCOLAB12 </span>,
        profile: 'Pra quem é funcionário',
        category: 'Entretenimento',
        partner: 'Original Experience',
        alt: 'Original Experience'
      },
      {
        link: 'https://essential.com.br/wp-content/uploads/2020/11/Essential-Proposta-Comercial-Parceria-Curso-de-Idiomas-in-Company-Itau.pdf',
        name: 'Essencial Idiomas',
        image: EssentialIndiomas,
        discount: 15,
        descriptionHtml: <span> 15% off + Isenção de Matrícula </span>,
        profile: 'Pra quem é funcionário',
        category: 'Educação',
        partner: 'Essencial Idiomas',
        alt: 'Essencial Idiomas'
      },
      {
        link: 'https://www.icarros.com.br/vender/indexfaces.jsf',
        name: 'Icarros',
        image: Icarros,
        descriptionHtml: <span>Anuncio com 100% off com o cupom ExclusivoItau</span>,
        profile: 'Pra quem é funcionário',
        category: 'Transporte',
        partner: 'Icarros',
        alt: 'Icarros'
      },
      {
        link: 'https://www.mahogany.com.br/iupp',
        name: 'Mahogany',
        discount: 15,
        image: Mahogany,
        descriptionHtml: <span>15% off em todo o site</span>,
        profile: 'Pra quem é funcionário',
        category: 'Perfumaria',
        partner: 'Mahogany',
        alt: 'Mahogany'
      },
      {
        link: 'https://www.dermage.com.br/',
        name: 'Dermage',
        discount: 20,
        image: Dermarge,
        descriptionHtml: <span>20% off com cupom ITAUCOLLAB20 </span>,
        profile: 'Pra quem é funcionário',
        category: 'Perfumaria',
        partner: 'Dermage',
        alt: 'Dermage'
      },
      {
        link: 'https://www.rentcars.com/pt-br/?utm_source=itauinterno&utm_medium=partner&utm_campaign=itauinterno-partner-itau&requestorid=4339',
        name: 'Rentcars',
        discount: 15,
        image: RendsCards,
        descriptionHtml: <span>15% em reservas online com cupom ITAU15 </span>,
        profile: 'Pra quem é funcionário',
        category: 'Transporte',
        partner: 'Rentcars',
        alt: 'Rentcars'
      },
      {
        link: 'https://www.mobly.com.br/itaucard/',
        name: 'Mobly',
        discount: 8,
        image: Mobly,
        descriptionHtml: <span>8% de desconto com o cupom ITAUCARD8</span>,
        profile: 'quem tem Itaucard',
        category: 'Casa e Decoração',
        partner: 'Mobly',
        alt: 'Logo Mobly'
      },
      {
        name: 'Evino',
        link: 'https://www.evino.com.br/',
        discount: 15,
        image: Evino,
        descriptionHtml: <span>15% off na 1ª compra com o cupom 15-IUPP</span>,
        profile: 'pra todo mundo',
        category: 'Bebidas',
        partner: 'Evino',
        alt: 'Logo Evino'
      },
      {
        link: 'https://prontolight.com/',
        name: 'Pronto Light',
        discount: 20,
        image: Prontolight,
        descriptionHtml: <span>15% off com o cupom IUPP15</span>,
        profile: 'pra todo mundo',
        category: 'Alimentos',
        partner: 'Pronto Light',
        alt: 'Logo Pronto Light'
      },
      {
        link: 'https://www.digitalhouse.com/br/acoes/itaucard',
        name: 'Digital House',
        image: DigitalHouse,
        descriptionHtml: <span> 40% off em cursos</span>,
        profile: 'quem tem Itaucard',
        category: 'Educação',
        partner: 'Digital House',
        alt: 'Logo Digital House'
      },
      {
        link: 'https://visabenefitslac.axa-assistance.us/',
        name: 'Visa',
        image: visa,
        descriptionHtml: <span>Conheça os benefícios que a Visa tem para você</span>,
        profile: 'quem tem Itaucard',
        category: 'Para você',
        partner: 'Visa',
        alt: 'Logo Visa'
      },
      {
        link: 'https://www.mastercard.com.br/pt-br/consumidores/encontre-seu-cartao/cartoes-credito.html',
        name: 'Mastercard®',
        image: MasterCard,
        descriptionHtml: <span>Conheça os benefícios do seu cartão Mastercard®</span>,
        profile: 'quem tem Itaucard',
        category: 'Para você',
        partner: 'Mastercard',
        alt: 'Logo Mastercard'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/adcos/',
        name: 'ADCOS',
        image: Adcos,
        discount: 10,
        descriptionHtml: <span>10% + 4 amostras nas compras na loja online</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida',
        partner: 'ADCOS',
        alt: 'Logo ADCOS'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/le-postiche/',
        name: 'Le postiche',
        image: Lepostiche,
        discount: 10,
        descriptionHtml: <span>15% off com o cupom ITAUPERSONNALITE15</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida',
        partner: 'Le postiche',
        alt: 'Logo Le postiche'
      },
      {
        link: 'https://zenklub.com.br/auth/signup/?referralCode=itauzen&h1=O%20seu%20benef%C3%ADcio%20Ita%C3%BA%20chegou!&h2=Aproveite%20o%20seu%20desconto%20sobre%20qualquer%20consulta',
        name: 'Zenklub',
        image: Zenklub,
        discount: 20,
        descriptionHtml: <span>20% off em consultas</span>,
        profile: 'quem tem Itaucard',
        category: 'Bem estar e saúde',
        partner: 'Zenklub',
        alt: 'Logo Zenklub'
      },
      {
        link: 'https://zenklub.com.br/auth/signup/?referralCode=itauzen&h1=O%20seu%20benef%C3%ADcio%20Ita%C3%BA%20chegou!&h2=Aproveite%20o%20seu%20desconto%20sobre%20qualquer%20consulta',
        name: 'Zenklub',
        image: Zenklub,
        discount: 20,
        descriptionHtml: <span>2 meses grátis no App + 20% off em consultas</span>,
        profile: 'Pra quem é funcionário',
        category: 'Bem estar e saúde',
        partner: 'Zenklub',
        alt: 'Logo Zenklub'
      },
      {
        link: 'http://www.onelink.to/tokbeauty',
        name: 'TokBeauty',
        image: Tokbeauty,
        discount: 15,
        descriptionHtml: <span>15% off nos demais com cupom ITAUCARD15</span>,
        profile: 'quem tem Itaucard',
        category: 'Perfumaria',
        partner: 'TokBeauty',
        alt: 'TokBeauty'
      },
      {
        link: 'https://carnegiebrasil.com.br/iupp',
        name: 'Carnegie',
        image: Carnegie,
        discount: 50,
        descriptionHtml: <span>30% off nos cursos com o cupom itaucard30</span>,
        profile: 'quem tem Itaucard',
        category: 'Educação',
        partner: 'Carnegie',
        alt: 'Carnegie'
      },
      {
        link: 'https://www.microsoft.com/pt-br/home-use-program',
        name: 'Microsoft',
        image: Microsoft,
        discount: 30,
        descriptionHtml: <span>30% em assinaturas do Microsoft 365</span>,
        profile: 'Pra quem é funcionário',
        category: 'Para você',
        partner: 'Microsoft',
        alt: 'Microsoft'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/cobasi/',
        name: 'Cobasi',
        image: Cobasi,
        discount: 10,
        descriptionHtml: <span>10% off no site utilizando o cupom PERSONNALITE</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida',
        partner: 'Cobasi',
        alt: 'Cobasi'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/cestas-michelli/',
        name: 'Cestas Michelli',
        image: CestasMichelli,
        discount: 20,
        descriptionHtml: <span>20% off pelo hotsite</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida',
        partner: 'Cestas Michelli',
        alt: 'Cestas Michelli'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/giuliana-flores/',
        name: 'Giuliana Flores',
        image: GiulianaFlores,
        discount: 20,
        descriptionHtml: <span>20% off pelo hotsite</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida',
        partner: 'Giuliana Flores',
        alt: 'Giuliana Flores'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/loccitane-en-provance/',
        name: `L'Occitane en Provence`,
        image: Looccitane,
        discount: 15,
        descriptionHtml: <span>15% off no site com o cupom PERSONNALITE</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida',
        partner: `L'Occitane en Provence`,
        alt: `L'Occitane en Provence`
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/original-experience/',
        name: 'Original Experience',
        image: OriginalExperience,
        discount: 20,
        descriptionHtml: <span>12% off com o cupom PERSONNALITE12 </span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida',
        partner: 'Original Experience',
        alt: 'Original Experience'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/loccitane-au-bresil/',
        name: `L'Occitane Au Brésil`,
        image: Loccitane,
        discount: 15,
        descriptionHtml: <span>15% off no site com o cupom PERSONNALITE15</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida',
        partner: `L'Occitane Au Brésil`,
        alt: `L'Occitane Au Brésil`
      },
      {
        link: 'https://www.loja.marelli.com.br/iupp-itau',
        name: 'Marelli',
        discount: 40,
        image: Marelli,
        descriptionHtml: <span>Até 40% off + frete grátis com o cupom eusouiupp</span>,
        profile: 'Pra quem é funcionário',
        category: 'Mobília',
        partner: 'Marelli',
        alt: 'Logo Marelli'
      },
      {
        link: 'http://itau.app-zen.com/paravoce',
        name: 'Zen App',
        discount: 55,
        image: ZenApp,
        descriptionHtml: <span>50% de desconto no plano anual</span>,
        profile: 'Pra quem é funcionário',
        category: 'Para você',
        partner: 'Zen App',
        alt: 'Logo Zen App'
      },
      {
        link: 'https://labfinprovarfia.com.br/parceriafiaeitau/',
        name: 'FIA',
        discount: 30,
        image: LogoFia,
        descriptionHtml: <span>De 15 a 30% off em Pós e MBA</span>,
        profile: 'Pra quem é funcionário',
        category: 'Educação',
        partner: 'FIA',
        alt: 'Logo FIA'
      },
      {
        link: 'https://bit.ly/38GXLuJ',
        name: 'Yuca',
        discount: 30,
        image: Yuca,
        descriptionHtml: <span>R$1000 off na 1ª mensalidade</span>,
        profile: 'Pra quem é funcionário',
        category: 'Para você',
        partner: 'Yuca',
        alt: 'Logo Yuca'
      },
      {
        link: 'https://hering.parceriasonline.com.br/iupp',
        name: 'Hering',
        discount: 15,
        image: Hering,
        descriptionHtml: <span>15% off em todo o site</span>,
        profile: 'Pra quem é funcionário',
        category: 'Moda',
        partner: 'Hering',
        alt: 'Logo Hering'
      }
    ]
    if (this.props.userProfile && !process.env.REACT_APP_CATALOG_ID_EMPLOYEE.includes(this.props.userProfile['custom:catalog_id'])) {
      this.benefits = this.benefits.filter(x => x.profile !== 'Pra quem é funcionário')
    }

    // #endregion
    this.buildFilters(this.benefits)
    this.filterBenefits()
    this.onOrderChange({ type: 'ASCENDING' })
  }

  render () {
    return (
      <Fragment>
        <div className='container-fluid px-0 d-flex justify-content-center'>
          <div className='container row px-0 pt-2 pb-3'>
            <div className='col-12 mt-2 d-block d-md-none'>
              <Button
                text='Filtrar'
                iconName='icon_filter'
                className={`col-12 btn-sm ${this.state.openFilter ? 'd-none' : ''}`}
                onClick={() => this.setState({ openFilter: true })}
              />
              <Button
                text='Voltar'
                iconName='icon_left icon-sm pt-3'
                className={`col-12 btn-sm btn-flat pt-5 ${this.state.openFilter ? '' : 'd-none'}`}
                onClick={() => this.setState({ openFilter: false })}
              />
              <div
                className={`float-button bg-white px-2 py-2 row mx-0 ${this.state.openFilter ? '' : 'd-none'}`}
              >
                <div className='col-12 px-0'>
                  <Button
                    className='btn btn-sm btn-featured'
                    text='Aplicar'
                    onClick={() => this.setState({ openFilter: false })}
                  />
                </div>
              </div>
              <div className={`col-12 ${this.state.openFilter ? '' : 'd-none'}`}>
                <Filter onOrderChange={this.onOrderChange} onFilterChange={this.onFilterChange} filters={this.state.filter} profiles={this.state.profiles} categories={this.state.categories} places={this.state.places} partners={this.state.partners} tags={this.state.tags} removeTags={this.removeTags} removeAllTags={this.removeAllTags} />
              </div>
            </div>
            <div className='col-3 mt-2 d-none d-md-block'>
              <Filter onOrderChange={this.onOrderChange} onFilterChange={this.onFilterChange} filters={this.state.filter} profiles={this.state.profiles} categories={this.state.categories} places={this.state.places} partners={this.state.partners} tags={this.state.tags} removeTags={this.removeTags} removeAllTags={this.removeAllTags} />
            </div>
            <div
              className={`col-12 col-md-9 mt-2 row parters-benefits-area mx-0 px-0 ${this.state.openFilter ? 'd-none' : ''}`}
            >
              <InfiniteScroll
                initialLoad={false}
                pageStart={0}
                loadMore={this.loadItems}
                hasMore={this.hasMoreItems}
                loader={
                  <Button loading text='Carregando' className='btn-flat' />
                }
                className='container row mx-0 px-0'
              >
                <div className='row col-12 mx-0 px-0'>
                  {this.state.filteredBenefits && this.state.filteredBenefits.map(this.getCardsBenefits)}
                </div>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = ({ oidc }) => {
  return {
    userProfile: oidc && oidc.user && oidc.user.profile
  }
}

export default connect(mapStateToProps)(ItauCardListing)



// WEBPACK FOOTER //
// ./src/features/Benefits/Listing/ItauCardListing.js